/**
 * CMS Section Mapping Configuration
 * Maps tab IDs to section IDs and metadata
 * Used by SectionForm to render dynamic forms
 */

export const sectionMapping = {
  // Homepage sections
  'cms-hero': {
    section_id: 40,
    section_type: 'hero',
    page: 'homepage',
    title: 'Hero Section'
  },
  'cms-quicklinks': {
    section_id: 42,
    section_type: 'quicklinks',
    page: 'homepage',
    title: 'Quick Links'
  },
  'cms-highlights': {
    section_id: 36,
    section_type: 'highlights',
    page: 'homepage',
    title: 'Highlights'
  },
  'cms-news': {
    section_id: 37,
    section_type: 'news',
    page: 'homepage',
    title: 'News'
  },
  'cms-countdown': {
    section_id: 38,
    section_type: 'countdown',
    page: 'homepage',
    title: 'Countdown'
  },

  // About Us sections
  'cms-about-hero': {
    section_id: 6,
    section_type: 'about-us',
    page: 'about-us',
    title: 'About Us'
  },
  'cms-about-principal': {
    section_id: 6,
    section_type: 'about-us',
    page: 'about-us',
    title: 'About Us'
  },
  'cms-about-values': {
    section_id: 6,
    section_type: 'about-us',
    page: 'about-us',
    title: 'About Us'
  },
  'cms-about-philosophy': {
    section_id: 6,
    section_type: 'about-us',
    page: 'about-us',
    title: 'About Us'
  },
  'cms-about-history': {
    section_id: 6,
    section_type: 'about-us',
    page: 'about-us',
    title: 'About Us'
  },
  'cms-about-leadership': {
    section_id: 6,
    section_type: 'about-us',
    page: 'about-us',
    title: 'About Us'
  },

  // Education Program sections
  'cms-education-hero': {
    section_id: 7,
    section_type: 'education-program-hero',
    page: 'education-program',
    title: 'Education Program Hero'
  }
};

/**
 * Get section config by tab ID
 * @param {string} tabId - The active tab ID
 * @returns {object} Section config with section_id, type, page
 */
export function getSectionConfig(tabId) {
  return sectionMapping[tabId] || null;
}

/**
 * Check if tab ID corresponds to a CMS section
 * @param {string} tabId - The tab ID
 * @returns {boolean} True if this is a CMS section tab
 */
export function isCMSTab(tabId) {
  return tabId && tabId.startsWith('cms-');
}
